import script from "./StockPrice.vue?vue&type=script&setup=true&lang=js"
export * from "./StockPrice.vue?vue&type=script&setup=true&lang=js"

import "./StockPrice.vue?vue&type=style&index=0&id=6ee4ad04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ee4ad04"]])

export default __exports__